import { useEffect } from "react";
import { toast } from "sonner";
import { trackPurchase } from "@/lib/analytics";

/**
 * Silent handler that runs when Stripe redirects back to the landing page after
 * a successful checkout. Fires the Meta Pixel + GA4 `Purchase` conversion
 * event with the correct value for the subscribed package, shows a success
 * toast, and cleans the query string so the event never double-fires.
 */
const PACKAGE_VALUES = {
  monitoring_month: 45,
  review_removal: 195,
};

const PACKAGE_LABELS = {
  monitoring_month: "Monitoring & Maintenance",
  review_removal: "Review Removal",
};

export default function PaymentSuccessListener() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("payment") !== "success") return;
    const pkg = params.get("package") || "monitoring_month";
    const value = PACKAGE_VALUES[pkg] ?? 0;

    trackPurchase(pkg, value);

    const label = PACKAGE_LABELS[pkg] || "subscription";
    toast.success(
      `You're in — welcome to ${label}. Confirmation and dashboard access are on their way to your inbox.`,
      { duration: 8000 }
    );

    // Clean the URL so the event and toast don't re-fire on browser refresh
    params.delete("payment");
    params.delete("session_id");
    params.delete("package");
    const qs = params.toString();
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}${qs ? `?${qs}` : ""}${window.location.hash}`
    );
  }, []);

  return null;
}
